module.exports = __webpack_public_path__ + "static/media/500.703d451e.png";